import { v4 as uuidv4 } from 'uuid';

const RIFF_SIGNATURE = [0x52, 0x49, 0x46, 0x46];
const WEBP_SIGNATURE = [0x57, 0x45, 0x42, 0x50];
const WEBP_SIGNATURE_OFFSET = 8;
const WEBP_HEADER_LENGTH = 12;
const JPEG_QUALITY = 0.85;

function readBlobAsArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result as ArrayBuffer);
    fileReader.onerror = () => reject(fileReader.error);
    fileReader.readAsArrayBuffer(blob);
  });
}

function canvasToBlob(
  canvas: HTMLCanvasElement,
  type: string,
  quality: number
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to encode canvas to blob'));
        }
      },
      type,
      quality
    );
  });
}

export async function isWebpFile(file: File): Promise<boolean> {
  if (file.size < WEBP_HEADER_LENGTH) {
    return false;
  }
  const header = new Uint8Array(
    await readBlobAsArrayBuffer(file.slice(0, WEBP_HEADER_LENGTH))
  );
  return (
    RIFF_SIGNATURE.every((byte, i) => header[i] === byte) &&
    WEBP_SIGNATURE.every(
      (byte, i) => header[i + WEBP_SIGNATURE_OFFSET] === byte
    )
  );
}

export async function convertWebpToJpeg(file: File): Promise<File> {
  const bitmap = await createImageBitmap(file);
  try {
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('Canvas 2D context is not available');
    }
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(bitmap, 0, 0);
    const blob = await canvasToBlob(canvas, 'image/jpeg', JPEG_QUALITY);
    return new File([blob], `${uuidv4()}.jpg`, { type: 'image/jpeg' });
  } finally {
    bitmap.close();
  }
}
